import React from "react";
import {AccountingPeriodRestControllerApiFactory, VatBook, VatBookRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";

export const VatBookEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(VatBookRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getVatBook(id),
        updater: (bean) => ctrl.saveVatBook(bean),
        remover: (id) => ctrl.deleteOrDismissVatBook(id),
        factory: () => ({
            year: new Date().getFullYear(),
            quarter: Math.ceil((new Date().getMonth() + 1) / 3),
            status: "PENDIENTE",
        } as unknown as VatBook),
        postLoad: (bean) => {
            if (!bean.id && !bean.period) {
                const periodCtrl = apiManager.factory(AccountingPeriodRestControllerApiFactory);
                apiManager.execute(periodCtrl.currentAccountingPeriod())
                    .then(period => form.triggerField('period', period))
                    .catch(() => {});
            }
        },
    } as UseFormProps<VatBook>);

    return (
        <FormContent form={form} title={"Libro de IVA"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={2}>
                    <FormInput field={"year"} label={"Año"} type="number"/>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <FormInput field={"quarter"} label={"Trimestre (1-4)"} type="number"/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormSelect
                        field={"bookType"}
                        label={"Tipo"}
                        type={types.vatBookTypes}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormSelect
                        field={"status"}
                        label={"Estado"}
                        type={types.taxSubmissionStatuses}
                    />
                </Grid>
            </Grid>

            <FormAutocomplete
                field={"period"}
                label={"Período contable"}
                type={types.accountingPeriods}
            />

            <Grid container spacing={3}>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"totalBase"} label={"Base total"} type="number" disabled/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"totalVat"} label={"IVA total"} type="number" disabled/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"netResult"} label={"Resultado neto"} type="number" disabled/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"presentationDate"} label={"Fecha presentación"} type="date"/>
                </Grid>
            </Grid>
        </FormContent>
    );
};
